import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  loading: false,
  keyword: '',
  keywordSearched: '',
  topics: [],
  topic: {},
  pages: 0,
  page: 1
}

const keywordSearch = createSlice({
  name: 'keywordSearch',
  initialState,
  reducers: {
    SET_KEYWORD: (state, { payload }) => {
      state.keyword = payload
    },
    SET_LOADING: (state, { payload }) => {
      state.loading = payload
    },
    SET_RESULTS: (state, { payload: { topics, pages } }) => {
      state.keywordSearched = state.keyword
      state.loading = false
      state.topics = topics
      state.pages = pages
    },
    CLEAR_RESULTS: () => {
      return initialState
    },
    SET_TOPIC: (state, { payload }) => {
      state.topic = payload
    },
    SET_RESULT_PAGE: (state, { payload }) => {
      state.page = payload
    }
  }
})

export default keywordSearch

export const keywordSearchActions = keywordSearch.actions

export const keywordSearchSelectors = {
  selectKeywordSearch: ({ keywordSearch }) => keywordSearch
}
